export function formatDate(dateString: string): string {
  const date = new Date(dateString)
  return new Intl.DateTimeFormat('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date)
}

export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength) + '...'
}

export function getImageUrl(path: string): string {
  if (!path) return ''

  // If it's a data URL, return as-is
  if (path.startsWith('data:')) return path

  const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'

  // If it's a full URL pointing to uploads, convert it to API endpoint
  if (path.startsWith('http')) {
    // Extract the uploads path from full URL
    const uploadsMatch = path.match(/\/uploads\/(.+)$/)
    if (uploadsMatch) {
      return `${API_URL}/media/serve/${uploadsMatch[1]}`
    }
    // If it's not an uploads URL, return as-is
    return path
  }

  // Convert uploads/ paths to use the new API endpoint
  // e.g., "uploads/media/2025/11/file.jpg" -> "/api/media/serve/media/2025/11/file.jpg"
  if (path.startsWith('uploads/')) {
    const pathWithoutUploads = path.replace('uploads/', '')
    return `${API_URL}/media/serve/${pathWithoutUploads}`
  }

  // For backward compatibility with paths that don't start with uploads/
  if (path.startsWith('/uploads/')) {
    const pathWithoutUploads = path.replace('/uploads/', '')
    return `${API_URL}/media/serve/${pathWithoutUploads}`
  }

  // For any other path, use the API endpoint
  return `${API_URL}/media/serve/${path.replace(/^\//, '')}`
}

export function getDocumentUrl(path: string): string {
  if (!path) return ''

  // If it's already a full URL, return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }

  // Get backend base URL from API URL (remove /api suffix)
  const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'
  const backendBaseUrl = API_URL.replace(/\/api\/?$/, '')

  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  // Return full URL to backend
  return `${backendBaseUrl}${normalizedPath}`
}
